<template>
    <div :class="{ 'can-change': is_editable }">
        <!-- viewing display -->
        <el-bar-dash-chart :values="duree_commerciale.table" />

        <!-- edition display -->
        <form v-if="is_editable && manual_edit" class="manual-edition">
            <el-table class="" :table="table_duree_commercialisation" :component="3" @changed_value="changed_value($event)"/>
        </form>

        <!-- Display error div -->
        <div  v-if="is_edit_mode &&  ((duree_commerciale && duree_commerciale.error) || (table_duree_commercialisation && table_duree_commercialisation.error)) "  class="error-container edit-error">
             <div class='content-error'> {{duree_commerciale.error_message}} </div>
        </div>
         <div  v-if="!is_edit_mode &&  ((duree_commerciale && duree_commerciale.error) || (table_duree_commercialisation && table_duree_commercialisation.error)) "  class="error-container read-error">
             <div class='content-error'> {{duree_commerciale.error_message}} </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import ElBarDashChart from "@/components/study/editor/elements/el-bar-dash-chart";
import ElTable from "@/components/study/editor/elements/el-table";

export default {
	name: "el-promo-duree-commercialisation",
	mixins: [ElementMixin],
	props: {
		is_OIP: { default: false },
		is_non_obs: { default: true },
		last_year_period: { default: null },
		data: {default: undefined},
		zone_geo: {default: undefined},
		zone_geo_quartier: {default: undefined},
		zone_geo_secteur: {default: undefined}
	},
	data () {
		return {
			volume_prix_chart_key: 0,
			copy_data: undefined
		};
	},
	computed: {
		...mapGetters(["active_study", "etude_data","app_parameters","editor"]),
		parameters () {
			try {
				const parametersPromo =
				this.active_study.qlikData.parameters.editmode.find((editmode) => {return editmode.theme == "marche_promotion_immobiliere";});
				return parametersPromo;
			} catch (e) {
				return false;
			}
		},
		manual_edit () {
			return this.is_OIP || this.is_non_obs;
		},
		is_edit_mode: function (){
			const result = this.editor.mode == "editing";
			return result;
		},
		table_duree_commercialisation () {
			let table = {
				head: [],
				body: [],
				config: {
					cols_width: [50, 50],
				},
			};

			try{
                            

				let elem;
				if(this.zone_geo == "quartier") {
                
					if(this.zone_geo_quartier == undefined)
						return table;
					elem = this.data.content.quartiers.find((quartier) => {
						return quartier.code == this.zone_geo_quartier;
					});
				}else if(this.zone_geo == "secteurs_adequation") {
					elem = this.data.content.secteurs_adequation.find((secteur) => {
						return secteur.code == this.zone_geo_secteur;
					});
				}else{
					elem = this.data.content[this.zone_geo];
				}
            
				for (let i = 0;i < elem.header_list.length; i++) {
					table.body.push([{
						parent_data: elem.header_list[i],
						property: "value",
						format: "number",
						editable: "true"
					},
					{
						parent_data: elem.data_list[i],
						property: "value",
						format: "number",
						editable: "true"
					}
					]);
				}

				const trimestreMaj = this.parameters.periods.values.find((val) => {
					return val.code == this.last_year_period;
				});
				const liste_annee = trimestreMaj.periods.find((per) => {
					return per.component_id == "temps_commercialisation_moyen";
				}).values;

				table.body = table.body.filter((elem) => {
					const result = liste_annee.split(",").indexOf(elem[0].parent_data.value) > -1;
					return result;
				});
				table.head.push(["Année", "Durée\ncommercialisation"]);
			} catch (error){
				//set empty table
				table = {
					head: [],
					body: [],
					config: {
						cols_width: [50, 50],
					},
				};
			}

			return table;
		},
		duree_commerciale: function () {
			const result = {};
			let x = [];
			try{
				let component = this.data;
				//todelete : switch mode error/nominal (false => error case)
				//component.valid = true;
				//throw "il y a une erreur"

				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false){
					result.error = true;
					//result.error_message = "[BACK] : "+component.errorMessage;
					result.error_message = "Donnée non disponible";
					// get default component
					component = this.app_parameters.default_components.find((component) => {
						return component.name == "temps commercialisation moyen" || component.id == "4.4";
					});
					x = [];
					for(let i = 0 ; i < component.content.epci.header_list.length ; i++){
						x.push({label: component.content.epci.header_list[i].value, value: parseInt(component.content.epci.data_list[i].value)});
					}
				}else{
					if(this.zone_geo == "quartier"){
						if(this.zone_geo_quartier == undefined)
							return x;
						const quartier = this.data.content.quartiers.find((quartier) => {
							return quartier.code == this.zone_geo_quartier;
						});
						for(let i = 0 ; i < quartier.header_list.length ; i++){
							x.push({label: quartier.header_list[i].value, value: parseInt(quartier.data_list[i].value)});
						}
					}else if(this.zone_geo == "secteurs_adequation") {
						if(this.data.content.secteurs_adequation) {
							const secteur = this.data.content.secteurs_adequation.find((secteur) => {
								return secteur.code == this.zone_geo_secteur;
							});
							for(let i = 0 ; i < secteur.header_list.length ; i++){
								x.push({label: secteur.header_list[i].value, value: parseInt(secteur.data_list[i].value)});
							}
						}
					}else{
						for(let i = 0 ; i < this.data.content[this.zone_geo].header_list.length ; i++){
							x.push({label: this.data.content[this.zone_geo].header_list[i].value, value: parseInt(this.data.content[this.zone_geo].data_list[i].value)});
						}
					}

					const trimestreMaj = this.parameters.periods.values.find((val) => {
						return val.code == this.last_year_period;
					});
					const liste_annee = trimestreMaj.periods.find((per) => {
						return per.component_id == "temps_commercialisation_moyen" || per.component_id == "4.4";
					}).values;
					x = x.filter((elem) => {
						const result = liste_annee.split(",").indexOf(elem.label) > -1;
						return result;
					});

				}
			}catch(error){
				result.error = true;
				// result.error_message = "[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				result.error_message = "Donnée non disponible";
				// get default component
				const component = this.app_parameters.default_components.find((component) => {
					return component.name == "temps commercialisation moyen" || component.id == "4.4";
				});
				x = [];
				for(let i = 0 ; i < component.content.epci.header_list.length ; i++){
					x.push({label: component.content.epci.header_list[i].value, value: parseInt(this.data.content.epci.data_list[i].value)});
				}
			}

			// add temp field
			x.forEach(function (item){
				let elem = item.label;
				// supprimer '*'
				elem = elem.replace("*","");
				// regarder que les 4 derniers char
				elem = elem.substring(elem.length - 4);
				item.tempLabel = elem;
			});
			// sort using temp field
			result.table = x.sort((a, b) => a.tempLabel > b.tempLabel ? 1 : -1);
			//remove temp field
			x.forEach(function (item){
				delete item.tempLabel;
			});
			return result;
		},
	},
	methods: {
		changed_value: function (event){
			let elem;
			if(this.zone_geo == "quartier") {
				elem = this.copy_data.content.quartiers.find((quartier) => {
					return quartier.code == this.zone_geo_quartier;
				});
			}else if(this.zone_geo == "secteurs_adequation") {
				elem = this.copy_data.content.secteurs_adequation.find((secteur) => {
					return secteur.code == this.zone_geo_secteur;
				});
			}else{
				elem = this.copy_data.content[this.zone_geo];
			}

			if(event.element == 0){
				elem.header_list[event.line].value = event.value;
			}else{
				elem.data_list[event.line].value = event.value;
			}

			this.$store.commit("SET_COMPONENT", {id: 3, content: this.copy_data});
			this.$store.dispatch("save_study");
		}
	},
	created () {
		this.copy_data = this.data;
	},
	components: {
		ElTable,
		ElBarDashChart,
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.error-container
    display flex
    justify-content center
    align-items center
    z-index: 990000
    position absolute
    top 0
    left 0
    width 100% !important
    height 180% !important
    text-align center
    border-style solid
    border-width 2px


.edit-error
	opacity 0.8
	background-color black
	color red
	border-color red
.read-error
	opacity 1
	background-color white
	color #3e5d58
	border-color #3e5d58

.manual-edition
    height 110px
    background-color alpha(white, 85%)
    position absolute
    left 0
    top 0px
    right 0
    bottom 0
</style>
